var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSurvey2Prediction = function SvgSurvey2Prediction(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 123,
    viewBox: "0 0 101 123",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.4766 33.6681V28.0773H70.3C69.9278 25.9931 69.1421 24.0578 68.0174 22.3624L71.003 19.3768L67.0497 15.4235L64.0972 18.376C62.4266 17.2099 60.5161 16.3663 58.4402 15.9528V11.7266H52.8494V15.9032C50.7653 16.2754 48.83 17.061 47.1345 18.1858L44.1489 15.2002L40.1957 19.1535L43.1482 22.106C41.9821 23.7766 41.1385 25.6871 40.725 27.763H36.4988V33.3538H40.6753C41.0475 35.4379 41.8332 37.3732 42.958 39.0686L39.9724 42.0543L43.9256 46.0075L46.8782 43.055C48.5488 44.2211 50.4593 45.0647 52.5351 45.4782V49.7044H58.1259V45.5279C60.2101 45.1557 62.1454 44.37 63.8408 43.2452L66.8264 46.2308L70.7797 42.2776L67.8271 39.325C68.9933 37.6544 69.8369 35.7439 70.2504 33.6681H74.4766ZM55.4877 39.5897C50.5833 39.5897 46.6135 35.6199 46.6135 30.7155C46.6135 25.8112 50.5833 21.8414 55.4877 21.8414C60.392 21.8414 64.3618 25.8112 64.3618 30.7155C64.3618 35.6199 60.392 39.5897 55.4877 39.5897Z",
    fill: "#A4B182"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1381 50.424L40.8825 46.0489L37.6156 45.4948C37.6074 43.8159 37.2435 42.1949 36.5818 40.7228L39.3194 38.7792L36.7472 35.1568L34.0428 37.0755C32.8932 35.9425 31.5038 35.0244 29.9407 34.429L30.5031 31.1208L26.128 30.3765L25.5739 33.6433C23.895 33.6598 22.274 34.0155 20.8019 34.6771L18.8583 31.9396L15.2359 34.5117L17.1546 37.2161C16.0216 38.3657 15.1035 39.7551 14.5081 41.3182L11.1999 40.7558L10.4556 45.1309L13.7224 45.685C13.7307 47.3639 14.0946 48.9849 14.7562 50.4571L12.0187 52.4006L14.5908 56.0231L17.2952 54.1043C18.4448 55.2374 19.8342 56.1554 21.3973 56.7509L20.835 60.059L25.21 60.8034L25.7641 57.5365C27.443 57.52 29.064 57.1644 30.5362 56.5027L32.4797 59.2402L36.1022 56.6681L34.1834 53.9637C35.3165 52.8141 36.2345 51.4247 36.83 49.8616L40.1381 50.424ZM24.4905 52.5412C20.653 51.8878 18.0726 48.2571 18.726 44.4196C19.3794 40.5822 23.0101 38.0018 26.8475 38.6552C30.685 39.3085 33.2654 42.9392 32.612 46.7767C31.9587 50.6142 28.328 53.1946 24.4905 52.5412Z",
    fill: "#B0CB1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.211 121.078C15.4674 120.003 15.7321 118.936 15.9884 117.869C17.7666 110.55 19.7515 103.272 21.2567 95.8948C22.3401 90.5521 20.6943 85.656 17.4109 81.3057C11.3983 73.3496 5.74138 65.8566 3.45047 55.9238C1.29189 46.6113 2.14374 36.5627 6.12182 27.8457C12.9036 13.0086 27.6497 3.74569 43.6365 2.19085C51.1874 1.45479 58.548 1.79387 65.8012 4.20884C75.0889 7.30198 83.3262 15.3822 87.263 24.2729C89.0576 28.3171 90.0749 32.7005 90.2817 37.1169C90.3809 39.2175 90.5132 41.6904 89.9343 43.7332C89.3388 45.8587 88.6441 47.4797 89.6118 49.7127C89.7689 50.0683 89.9508 50.4157 90.1576 50.7548C92.0846 53.9141 94.144 56.9907 96.1371 60.1086C96.9807 61.4236 97.8905 62.6973 98.61 64.0784C99.8505 66.4438 99.4205 67.5603 97.0221 68.8422C95.3762 69.7271 93.0109 70.2647 92.3245 71.6376C91.9027 72.4812 92.5478 73.6391 92.8703 74.4082C93.3252 75.5082 93.7966 76.666 93.6891 77.8901C93.6395 78.4442 93.4327 79.0066 93.0026 79.3622C92.8538 79.4862 92.6801 79.5855 92.5395 79.7095C92.3989 79.8419 92.2831 80.0156 92.2914 80.214C92.3327 81.0494 93.2342 81.1734 93.0026 82.1741C92.8041 83.0508 92.1177 83.7869 91.4643 84.3658C89.1238 86.4334 90.7283 90.7423 90.505 93.2896C90.3478 95.076 89.6283 96.8955 88.2058 97.9955C85.2863 100.253 80.6549 99.0872 77.3467 98.5578C72.1115 97.7308 65.305 98.2188 64.7012 104.876C64.1967 110.409 64.8584 116.017 66.62 121.285",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6147 16.6642C50.3019 15.5394 52.2207 14.7454 54.2883 14.3815",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2219 26.2082C42.6354 24.1489 43.4625 22.2467 44.6286 20.5844",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4382 37.4725C43.3134 35.7854 42.5194 33.8666 42.1555 31.799",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9823 43.8739C51.923 43.4603 50.0125 42.6333 48.3584 41.4672",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2468 41.649C63.5596 42.7738 61.6408 43.5678 59.5732 43.9317",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6479 32.1133C71.2344 34.1726 70.4073 36.0831 69.2412 37.7372",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4233 20.8407C70.5481 22.5279 71.3421 24.4466 71.706 26.5142",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8872 14.4476C61.9465 14.8612 63.8487 15.6882 65.5111 16.8543",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7783 37.0007C69.1094 32.6695 69.1094 25.6473 64.7783 21.3162C60.4471 16.985 53.4249 16.985 49.0937 21.3162C44.7626 25.6473 44.7626 32.6695 49.0937 37.0007C53.4249 41.3319 60.4471 41.3319 64.7783 37.0007Z",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2966 14.3897V10.1718H59.8874V14.4476",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5115 16.8461L68.4971 13.8687L72.4504 17.822L69.4317 20.8407",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7058 26.5225H75.9238V32.1133H71.6479",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2497 37.7372L72.2271 40.7228L68.2738 44.6761L65.2551 41.6491",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5732 43.9317V48.1497H53.9824V43.8738",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3586 41.4754L45.3729 44.4528L41.4197 40.4995L44.4384 37.4725",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.164 31.799H37.946V26.2082H42.2219",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6204 20.5761L41.6431 17.5987L45.5963 13.6454L48.615 16.6642",
    stroke: "#32332B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4578 16.8212C50.1449 15.6964 52.0637 14.9025 54.1313 14.5386",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0647 26.3653C42.4782 24.3059 43.3053 22.4037 44.4714 20.7414",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2812 37.6296C43.1564 35.9425 42.3624 34.0237 41.9985 31.9561",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8253 44.0309C51.766 43.6174 49.8555 42.7903 48.2014 41.6242",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0895 41.8062C63.4024 42.9309 61.4836 43.7249 59.416 44.0888",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4909 32.2704C71.0774 34.3297 70.2504 36.2402 69.0842 37.8943",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2664 20.9978C70.3911 22.685 71.1851 24.6037 71.549 26.6713",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7302 14.6047C61.7896 15.0183 63.7 15.8453 65.3541 17.0114",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7777 38.1919C61.6788 38.1919 65.6519 34.2188 65.6519 29.3178C65.6519 24.4167 61.6788 20.4436 56.7777 20.4436C51.8767 20.4436 47.9036 24.4167 47.9036 29.3178C47.9036 34.2188 51.8767 38.1919 56.7777 38.1919Z",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1396 14.5468V10.3289H59.7305V14.6047",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3542 17.0031L68.3399 14.0258L72.2931 17.979L69.2744 20.9977",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5489 26.6796H75.7668V32.2704H71.491",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0925 37.8943L72.0699 40.8799L68.1166 44.8332L65.0979 41.8062",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4162 44.0888V48.3067H53.8254V44.0309",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2016 41.6325L45.216 44.6098L41.2627 40.6566L44.2814 37.6296",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.007 31.9561H37.7891V26.3653H42.0649",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4634 20.7331L41.4861 17.7558L45.4393 13.8025L48.4581 16.8212",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1829 33.5109C23.655 32.8824 25.2677 32.5516 26.9384 32.5681",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8064 39.9949C16.4267 38.4566 17.353 37.092 18.5026 35.9672",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8807 49.0924C15.2521 47.6203 14.9213 46.0075 14.9378 44.3369",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3649 55.4689C20.8266 54.8486 19.4619 53.9224 18.3372 52.7728",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4625 55.3945C29.9904 56.023 28.3777 56.3538 26.707 56.3373",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8387 48.9104C37.2185 50.4487 36.2922 51.8133 35.1426 52.9381",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7642 39.8129C38.3927 41.2851 38.7235 42.8978 38.707 44.5684",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2803 33.4365C32.8186 34.0567 34.1832 34.983 35.308 36.1326",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7284 45.7594C33.0089 49.5721 29.3285 52.0863 25.5159 51.3668C21.7032 50.6472 19.189 46.9669 19.9085 43.1542C20.6281 39.3416 24.3084 36.8274 28.1211 37.5469C31.9337 38.2664 34.4479 41.9468 33.7284 45.7594Z",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9382 32.5681L27.5585 29.2847L31.9088 30.1118L31.2802 33.4365",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3081 36.1326L38.0704 34.2469L40.5681 37.9107L37.7644 39.8129",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7073 44.5684L41.9906 45.1887L41.1718 49.5389L37.8389 48.9104",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1427 52.9381L37.0284 55.7004L33.3729 58.1898L31.4624 55.3944",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7066 56.3373L26.0863 59.6206L21.7361 58.8019L22.3646 55.4689",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3372 52.7727L15.5831 54.6584L13.0854 51.0029L15.8809 49.0924",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9379 44.3369L11.6545 43.7166L12.4816 39.3664L15.8063 39.9949",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5026 35.9672L16.6169 33.2132L20.2807 30.7155L22.1829 33.5109",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSurvey2Prediction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/survey_2_prediction.944effb4.svg";
export { ForwardRef as ReactComponent };